"use client";

import RegularMeetingsPrototype from "@/components/staff/panels/governance/RegularMeetingsPrototype";
import { TourButton } from "@/components/tours/TourButton";
import { useAutoTour } from "@/components/tours/useAutoTour";
import { TOURS } from "@/components/tours/catalog";

export function GovernanceProjectsPanel() {
    const { replay: replayTour } = useAutoTour("staff.governance", TOURS["staff.governance"]);
    return (
        <div className="space-y-2">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mb-1">
                <span className="text-xs font-bold uppercase tracking-widest text-[#007a8a] bg-[#007a8a]/10 px-2 py-0.5 rounded">
                    Prototype v1.0
                </span>
                <span className="text-xs text-gray-400">Governance projects · Regular meetings · real committees, people and policies; meeting dates and statuses are sample · nothing is really sent (comments are saved)</span>
                <span className="ml-auto"><TourButton onClick={replayTour} /></span>
            </div>
            <div id="governance-rm-body">
                <RegularMeetingsPrototype />
            </div>
        </div>
    );
}
